import React, { useMemo } from 'react';
import { useTable } from 'react-table';
import ActionComponent from '../../pages/Activity/Component/ActionComponent';

const DataTableDynamic = ({ columns, elementClass, data, actions, moduleActions, enableCustom = false }) => {

  const handleAction = (rowData, callback) => {
    callback(rowData);
  };

  // Prepare columns with actions
  const columnsWithActions = useMemo(
    () => [
      ...columns,
      {
        Header: 'Actions',
        id: 'actions',
        Cell: ({ row }) => (
          <div className="justify-center space-x-2">
            {actions?.map((action, index) => {
              return (
                <button
                  key={index}
                  onClick={() => {
                    handleAction(row.original, action.callback)
                  }}
                  className={action.className}>
                  {action.child ?? action.title}
                </button>
              );
            })}
            {moduleActions?.map((action, index) => (
              <ActionComponent
                key={index}
                action={action}
                triggerData={row.original}
                custom={enableCustom}
              />
            ))}
          </div>
        ),
      },
    ],
    [columns, actions, moduleActions, enableCustom] // Add necessary dependencies
  );

  // Handle image rendering
  const renderCellContent = (value, type) => {
    const maxLength = 15;
    if (type === 'image' && value) {
      return <img src={`${process.env.REACT_APP_API_BASE_URL}/upload/${value}`} alt="Image" className="w-20 h-20 object-contain" />;
    } else if (type === 'html') {
      return <span dangerouslySetInnerHTML={{ __html: value }} />
    } else if (type === 'hidden') {
      return <></>
    } else if (type === 'currency') {
      return (
        <p className="text-end">{value}</p>
      );
    } else if (typeof value == 'text' && value.length > maxLength) {
      return (
        <span>
          {value.substring(0, maxLength)}...
          <span className="text-blue-500 cursor-pointer">Read more</span>
        </span>
      );
    }
    return value;
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns: columnsWithActions,
    data,
  });

  return (
    <div className={`relative overflow-x-auto ${elementClass}`}>
      {columns.length > 0 ? (
        <>
        
          <table {...getTableProps()} className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="bg-gray-100">
              {headerGroups.map(headerGroup => {
                const { getHeaderGroupProps, headers } = headerGroup;
                return (
                  <tr {...getHeaderGroupProps()} key={headerGroup.id}>
                    {headers.map(column => {
                      const { getHeaderProps, render } = column;
                      return (
                        <th
                          {...getHeaderProps()}
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          key={column.id}
                        >
                          {render('Header')}
                        </th>
                      );
                    })}
                  </tr>
                );
              })}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map(row => {
                prepareRow(row);
                return (
                  <tr key={row.id} {...row.getRowProps()} className="border-b border-gray-200 hover:bg-gray-50">
                    {row.cells.map(cell => {
                      const { value, column } = cell;
                      const cellProps = { ...cell.getCellProps(), className: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" };

                      return (
                        <td key={column.id} {...cellProps}>
                          {column.id === "actions" ? cell.render('Cell') : renderCellContent(value?.value, value?.type)}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>

          </table>
        </>) : <div className=''>
        <span className='font-bold'>Data tidak ditemukan</span>
      </div>
      }
    </div>
  );
};

export default DataTableDynamic;
